<template>
  <div class="modalImage">
    <!-- Modal Content (The Image) -->
    <a @click="imageZoom = !imageZoom">
      <div
        class="modal-image-container"
        :style="{ 'background-image': 'url(' + url + ')' }"
        :class="{'img-modal-zoom': imageZoom}"
      />
    </a>
    <!-- Modal Caption (Image Text) -->
    <div v-if="url !== ''" id="caption">
      <div class="caption-container">
        {{ title }}
        <!-- The Close Button -->
        <slot name="close-modal" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ModalImage',
  props: {
    url: {
      type: String
    },
    title: {
      type: String
    }
  },
  data: () => ({
    imageZoom: false
  }),

  mounted () {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const payload = {
          modal: false,
          url: ''
        }
        this.$store.dispatch('consultation/setPreviewImage', payload)
      }
    })
  }
}
</script>
<style lang='scss'>
/* The Modal (background) */
.modal-image-container{
  background-repeat: no-repeat;
  height: calc(100vh - 8rem);
  background-position: center;
  background-size: contain;
  width: 80%;
  max-width: 700px;
  margin: 0 auto;
  cursor: zoom-in;
  &.img-modal-zoom {
    cursor: zoom-out;
    transform: scale(2);
  }
}
.modalImage {
  position: fixed; /* Stay in place */
  z-index: 999999; /* Sit on top */
  padding-top: 3rem; /* Location of the box */
  padding-bottom: 2rem; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}
/* Modal Content (Image) */
.modal-image-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  cursor: zoom-in;
  transform: scale(1);
  transition: all .3s ease-in-out;
  &.img-modal-zoom {
    cursor: zoom-out;
    transform: scale(2);
  }
}
.modal-content-pdf {
  width: 100%;
  height: 100%;
}
/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 100%;
  // max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 70px;
  position: fixed;
  bottom: 0;
  .caption-container{
    width: 80%;
    max-width: 700px;
    display: flex;
    height: 100px;
    margin: 0 auto;
    position: relative;
  }
}
.words-ellipsis {
  vertical-align: middle;display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/* Add Animation - Zoom in the Modal */
#caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}
@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}
/* The Close Button */
.close-modal-image {
  position: absolute;
  top: 15px;
  right: 0;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
  z-index: 999999;
}
.close-modal-image:hover,
.close-modal-image:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}
</style>
